import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogIn, ArrowLeft } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import SEOHead from "@/components/SEOHead";

export default function PatientLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", form);
      toast.success("Sesión iniciada");
      window.location.href = "/paciente/panel";
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <>
      <SEOHead title="Portal del paciente · Iniciar sesión" description="Accede a tu cuenta para gestionar tus citas y tu historial médico." path="/paciente/login" />
      <section className="mx-auto max-w-md px-6 py-16 lg:py-24" data-testid="patient-login-page">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-[hsl(var(--clinic-muted))]"><ArrowLeft size={14} /> Volver al inicio</Link>
        <div className="mt-6 rounded-3xl border border-[hsl(var(--clinic-border))] bg-white p-8">
          <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--clinic-muted))]">Portal del paciente</div>
          <h1 className="mt-1 font-display text-3xl">Iniciar sesión</h1>
          <form onSubmit={submit} data-testid="patient-login-form" className="mt-6 grid gap-4">
            <label className="block">
              <span className="text-xs font-semibold uppercase tracking-widest text-[hsl(var(--clinic-muted))]">Correo</span>
              <input required type="email" data-testid="pl-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1 w-full rounded-xl border border-[hsl(var(--clinic-border))] px-4 py-3 text-sm" />
            </label>
            <label className="block">
              <span className="text-xs font-semibold uppercase tracking-widest text-[hsl(var(--clinic-muted))]">Contraseña</span>
              <input required type="password" data-testid="pl-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1 w-full rounded-xl border border-[hsl(var(--clinic-border))] px-4 py-3 text-sm" />
            </label>
            <button type="submit" disabled={loading} data-testid="pl-submit" className="inline-flex items-center justify-center gap-2 rounded-full bg-[hsl(var(--clinic-secondary))] px-6 py-3 text-sm font-semibold text-white disabled:opacity-60">
              <LogIn size={16} /> {loading ? "Entrando…" : "Entrar"}
            </button>
          </form>
          <p className="mt-4 text-sm text-[hsl(var(--clinic-muted))]">
            ¿No tienes cuenta? <Link to="/paciente/registro" className="font-semibold text-[hsl(var(--clinic-secondary))] underline">Regístrate</Link>
          </p>
        </div>
      </section>
    </>
  );
}
